/* eslint-disable fp/no-mutating-methods */
import { useTranslation } from 'next-i18next'

import { ButtonPrimary } from '~/components/Buttons/ButtonPrimary'

interface Props {
  activePageId: number | undefined
  totalPages: number
  path: string
}

const TipsNavigation = ({ activePageId, totalPages, path }: Props): React.ReactElement => {
  const { t } = useTranslation('studyTips')

  const previousLink = activePageId && activePageId > 1 ? `${path}${activePageId - 1}` : undefined
  const nextLink = activePageId && activePageId !== totalPages ? `${path}${activePageId + 1}` : undefined

  return (
    <>
      <div className="grid gap-8 grid-cols-8 items-center mt-5">
        {previousLink && (
          <ButtonPrimary
            className="col-start-1 col-span-4 md:col-span-2 border-2 border-white"
            disableRing
            href={previousLink}
            isFullWidth
            size="small"
          >
            {t('prevTips')}
          </ButtonPrimary>
        )}
        {nextLink && (
          <ButtonPrimary
            className="col-start-5 md:col-start-7 col-span-4 md:col-span-2 border-2 border-white"
            disableRing
            href={nextLink}
            isFullWidth
            size="small"
          >
            {t('nextTips')}
          </ButtonPrimary>
        )}
      </div>
    </>
  )
}

export default TipsNavigation
